"use client";

import { useEffect, useState } from "react";
import { useBookStore } from "@/stores/useBookStore";
import { usePathname } from "next/navigation";
import { Markdown } from "@/components/ui/Markdown";

export function SiteNotificationBanner() {
  const notifications = useBookStore((state) => state.siteNotifications);
  const loading = useBookStore((state) => state.siteNotificationsLoading);
  const loadNotifications = useBookStore((state) => state.loadSiteNotifications);
  const pathname = usePathname();
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const mutedUntil = localStorage.getItem("siteNotificationsMutedUntil");
    const now = Date.now();
    if (mutedUntil && now < parseInt(mutedUntil, 10)) {
      setHidden(true);
      return;
    }

    if (pathname.startsWith("/books") || pathname.startsWith("/book/")) {
      loadNotifications();
    }
  }, [loadNotifications, pathname]);

  const closeBanner = () => {
    const mutedUntil = Date.now() + 24 * 60 * 60 * 1000;
    localStorage.setItem("siteNotificationsMutedUntil", mutedUntil.toString());
    setHidden(true);
  };

  if (hidden || loading || !notifications || notifications.length === 0) {
    return null;
  }

  return (
    <div className="w-full bg-yellow-50 text-yellow-800 border-b border-yellow-200 text-left text-sm relative px-3 py-2">
      <button
        onClick={closeBanner}
        aria-label="Close notification"
        className="absolute right-2 top-1/2 -translate-y-1/2 text-yellow-800"
      >
        ×
      </button>
      {notifications.map((n) => (
        <Markdown key={n.id} content={n.message} />
      ))}
    </div>
  );
}
